var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { insertExternalScript } from '../../util/insertScript';
import { GLOBAL_SRC } from './scriptSrc';
import { getCookie } from '../../util/getCookie';
import { push as dataLayerPush, gtag as dataLayerGtag } from './../dataLayer';
import { getDomain } from '../../util/getDomain';
var DOMAIN_SCRIPT_ID = '50da44be-0564-43df-b139-329aedcf267b';
var consentListenersOnLoad = new Set();
var consentListenersOnChange = new Set();
export function load(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var loadTimer;
        var _c = _b.timeout, timeout = _c === void 0 ? 5000 : _c, oneTrustDomainScript = _b.oneTrustDomainScript;
        return __generator(this, function (_d) {
            window.OptanonWrapper = handleLoad;
            return [2, new Promise(function (resolve, reject) {
                    insertExternalScript({
                        dataset: {
                            domainScript: oneTrustDomainScript
                                ? oneTrustDomainScript
                                : DOMAIN_SCRIPT_ID,
                            documentLanguage: 'true',
                        },
                        onError: function () { return reject(); },
                        onLoad: function (e) { return resolve(e); },
                        src: GLOBAL_SRC,
                    });
                    loadTimer = setTimeout(reject, timeout);
                }).then(function () { return clearTimeout(loadTimer); })];
        });
    });
}
export function handleLoad() {
    var _a;
    if (!window.gtag) {
        window.gtag = dataLayerGtag;
    }
    var consentInfo = getConsentInfo();
    if (consentInfo) {
        consentListenersOnLoad.forEach(function (cb) {
            try {
                cb(consentInfo);
            }
            catch (e) {
            }
        });
    }
    (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.OnConsentChanged(onConsentChange);
    if ((window.__cmp || window.__tcfapi) &&
        window.OptanonActiveGroups &&
        (consentInfo === null || consentInfo === void 0 ? void 0 : consentInfo.consentId)) {
        handleLoadSuccess(consentInfo.consentId);
        var oneTrustLoadSuccessEvent = new Event('oneTrustLoadSuccess');
        document.dispatchEvent(oneTrustLoadSuccessEvent);
    }
}
function handleLoadSuccess(consentId) {
    if (window.__tcfapi) {
        window.__tcfapi('getTCData', 2, handleVendorConsentsV2(consentId));
    }
    else {
        window.__cmp('getVendorConsents', {}, handleVendorConsentsV1(consentId));
    }
}
function handleVendorConsentsV1(consentId) {
    return function handleConsents(data) {
        var consentData = JSON.stringify({
            id: consentId,
            iab: data.metadata,
            cate: window.OptanonActiveGroups,
        });
        setConsentCookie();
        dataLayerPush({ consentData: consentData });
    };
}
function handleVendorConsentsV2(consentId) {
    return function handleConsents(data, success) {
        if (!success) {
            return;
        }
        var consentData = JSON.stringify({
            id: consentId,
            iab: data.tcString,
            cate: window.OptanonActiveGroups,
        });
        setConsentCookie();
        dataLayerPush({ consentData: consentData });
    };
}
var CONSENT_COOKIE_NAME = 'sp_consent';
var CONSENT_COOKIE_MAX_AGE = -1000;
function setConsentCookie() {
    var domain = getDomain(window.location.hostname);
    document.cookie = [
        "".concat(CONSENT_COOKIE_NAME, "="),
        "max-age=".concat(CONSENT_COOKIE_MAX_AGE),
        "domain=".concat(domain),
        'path=/',
    ].join('; ');
}
function onConsentChange() {
    var consentInfo = getConsentInfo();
    if (consentInfo) {
        consentListenersOnChange.forEach(function (cb) {
            try {
                cb(consentInfo);
            }
            catch (e) {
            }
        });
    }
}
export function addConsentListener(callback, emitOnLoad) {
    if (emitOnLoad) {
        consentListenersOnLoad.add(callback);
    }
    consentListenersOnChange.add(callback);
}
export function removeConsentListener(callback) {
    consentListenersOnLoad.delete(callback);
    consentListenersOnChange.delete(callback);
}
export function getConsentInfo() {
    var cookieString = getCookie('OptanonConsent');
    var _a = parseOptanonCookie(cookieString), groupString = _a.groups, consentId = _a.consentId, datestamp = _a.datestamp;
    if (!consentId || !datestamp || datestamp === '') {
        return undefined;
    }
    var groups = parseGroupString(groupString);
    var date = parseDate(datestamp);
    return { groups: groups, consentId: consentId, date: date };
}
function parseGroupString(groupString) {
    if (!groupString) {
        return {};
    }
    return groupString
        .split(',')
        .reduce(function (acc, pair) {
        var _a = pair.split(':'), key = _a[0], consentGiven = _a[1];
        acc[key] = consentGiven === '1';
        return acc;
    }, {});
}
function parseOptanonCookie(cookie) {
    return ((cookie === null || cookie === void 0 ? void 0 : cookie.split('&').reduce(function (acc, val) {
        var _a = val.split('='), key = _a[0], value = _a[1];
        if (key) {
            acc[key] = decodeURIComponent(value);
        }
        return acc;
    }, {})) || {});
}
function parseDate(date) {
    var dateStampWithoutPlus = date.replace(/\+/g, ' ');
    return new Date(dateStampWithoutPlus);
}
